package com.essntl.features.category.domain.repository

import com.essntl.features.category.domain.model.CategoryModel

interface CategoryRepository {
    suspend fun getAll(includeExtra: Boolean = false): Result<List<CategoryModel>>
    suspend fun getByIds(ids: List<String>): Result<List<CategoryModel>>
    suspend fun getById(id: String): Result<CategoryModel>
    suspend fun getExtraCategory(): Result<CategoryModel?>
    suspend fun getCountCategoriesByName(name: String): Result<Long>
    suspend fun insert(category: CategoryModel): Result<CategoryModel>
    suspend fun update(category: CategoryModel): Result<CategoryModel>
    suspend fun delete(category: CategoryModel): Result<Unit>
}
